

export type ScenarioLane = 'bing' | 'google' | 'common' | 'neuro';

export type ScenarioLike = {
  id?: string;
  name: string;
  engine?: string;
  lane?: string;
  depth?: number;
  dwell?: number;
  bounce?: number;
  queries?: string[];
};

export function scenarioLane(raw: unknown): ScenarioLane {
  const v = String(raw || '').toLowerCase();
  if (v === 'common' || v === 'общий' || v === 'оба' || v === 'both' || v === 'all') return 'common';
  if (v === 'neuro' || v.includes('neuro') || v.includes('copilot') || v.includes('нейро')) return 'neuro';
  if (v === 'google' || v.includes('google')) return 'google';
  if (v === 'bing' || v.includes('bing')) return 'bing';
  return 'bing';
}


export function scenariosForEngine(scenarios: ScenarioLike[], engine: string): ScenarioLike[] {
  const lane = engine === 'google' ? 'google' : 'bing';
  return scenarios.filter((s) => {
    const l = scenarioLane(s.lane || s.engine || s.name);
    return l === 'common' || l === lane;
  });
}

export function scenarioNames(scenarios: ScenarioLike[], engine: string): string[] {
  return scenariosForEngine(scenarios, engine).map((s) => s.name);
}

export function scenByName(scenarios: ScenarioLike[], engine: string, name: string | undefined): ScenarioLike | undefined {
  return scenarios.find((x) => x.name === name) || scenariosForEngine(scenarios, engine)[0] || scenarios[0];
}

export function scenariosForNeuro(scenarios: ScenarioLike[]): ScenarioLike[] {
  return scenarios.filter((s) => scenarioLane(s.lane || s.engine || s.name) === 'neuro');
}
